import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import './AutoInsuranceOcfModuleView.scss';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import AutoInsuranceFilters from 'partial/OfferManager/modules/AutoInsuranceModule/components/AutoInsuranceFilters';
import AutoInsuranceOfferView from 'partial/OfferManager/modules/AutoInsuranceModule/components/AutoInsuranceOfferView';
import 'partial/OfferManager/modules/AutoInsuranceModule/AutoInsuranceModule.style.scss';
import MoreWaysToBrowseCard from 'pages/Ocf/components/MoreWaysToBrowseCard';

const AutoInsuranceOcfModuleView = props => {
  return (
    <>
      <SectionContainer
        className={'autoInsuranceOcfContainer autoInsuranceModule margT8'}
      >
        <FlexContainer
          className={
            'headerContainer padLR48 m-padLR16 justify-between m-margB8'
          }
        >
          <FlexContainer
            className={'titleSection flex-column margT54 m-margT0'}
          >
            <Label className={'H3 m-H3'}>
              {'Find a better auto insurance plan!'}
            </Label>
            <Label className={'Body-1 margT8 mBody-2'}>
              {
                'When was the last time you checked your auto insurance policy? See if you can save cash and get better coverage too.'
              }
            </Label>
          </FlexContainer>
          <FlexContainer className={'imageSection m-hide'}>
            <Image imgClass={'autoInsuranceImage bgImageW254'} />
          </FlexContainer>
        </FlexContainer>

        <AutoInsuranceFilters {...props} />
        <AutoInsuranceOfferView {...props} />
      </SectionContainer>
      <MoreWaysToBrowseCard />
    </>
  );
};

export default AutoInsuranceOcfModuleView;
